var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobe(_ref, svgRef) {
  var _ref2, _ref3, _ref4;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.25 10.5C1.25 12.8206 2.17187 15.0462 3.81282 16.6872C5.45376 18.3281 7.67936 19.25 10 19.25C12.3206 19.25 14.5462 18.3281 16.1872 16.6872C17.8281 15.0462 18.75 12.8206 18.75 10.5C18.75 8.17936 17.8281 5.95376 16.1872 4.31282C14.5462 2.67187 12.3206 1.75 10 1.75C7.67936 1.75 5.45376 2.67187 3.81282 4.31282C2.17187 5.95376 1.25 8.17936 1.25 10.5Z",
    stroke: "#1A4338",
    style: (_ref2 = {
      stroke: "#1A4338"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.1020 0.2627 0.2196)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 10.5C6.25 8.17936 6.64509 5.95376 7.34835 4.31282C8.05161 2.67187 9.00544 1.75 10 1.75C10.9946 1.75 11.9484 2.67187 12.6516 4.31282C13.3549 5.95376 13.75 8.17936 13.75 10.5C13.75 12.8206 13.3549 15.0462 12.6516 16.6872C11.9484 18.3281 10.9946 19.25 10 19.25C9.00544 19.25 8.05161 18.3281 7.34835 16.6872C6.64509 15.0462 6.25 12.8206 6.25 10.5Z",
    stroke: "#1A4338",
    style: (_ref3 = {
      stroke: "#1A4338"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.1020 0.2627 0.2196)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.875 13.4167H18.125M1.875 7.58337H18.125",
    stroke: "#1A4338",
    style: (_ref4 = {
      stroke: "#1A4338"
    }, _defineProperty(_ref4, "stroke", "color(display-p3 0.1020 0.2627 0.2196)"), _defineProperty(_ref4, "strokeOpacity", 1), _ref4),
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.d1ee882b.svg";
export { ForwardRef as ReactComponent };